import React from 'react';
import { TimesheetSummaryReport as TimesheetSummaryReportData } from '../../models/Report';
import { ExportDropdown } from './ExportDropdown';
import { rowsToCsv, downloadCsv, todayStamp } from '../../utils/csv';

interface Props {
  data: TimesheetSummaryReportData;
  onBack?: () => void;
}

export const TimesheetSummaryReport: React.FC<Props> = ({ data }) => {
  const handleExportCSV = () => {
    const csv = rowsToCsv(data.byRBT, [
      { header: 'RBT Name', get: (r) => r.rbtName },
      { header: 'Timesheets', get: (r) => r.timesheetCount },
      { header: 'Total Hours', get: (r) => r.totalHours },
      { header: 'Overtime Hours', get: (r) => r.overtimeHours },
      { header: 'Mileage (mi)', get: (r) => r.mileage },
      { header: 'Status', get: (r) => r.status },
    ]);
    downloadCsv(`timesheet-summary_${todayStamp()}.csv`, csv);
  };

  return (
  <div>
    {/* Toolbar */}
    <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 'var(--spacing-4)' }}>
      <ExportDropdown onExportCSV={handleExportCSV} />
    </div>

    <div className="grid grid-cols-4" style={{ gap: 'var(--spacing-4)', marginBottom: 'var(--spacing-6)' }}>
      <div className="card">
        <div style={{ fontSize: 'var(--text-sm)', color: 'var(--color-gray-600)' }}>
          Total Hours
        </div>
        <div style={{ fontSize: 'var(--text-3xl)', fontWeight: 'var(--font-bold)' }}>
          {data.totalHours}
        </div>
      </div>
      <div className="card">
        <div style={{ fontSize: 'var(--text-sm)', color: 'var(--color-gray-600)' }}>
          Overtime Hours
        </div>
        <div style={{ fontSize: 'var(--text-3xl)', fontWeight: 'var(--font-bold)', color: 'var(--color-warning)' }}>
          {data.totalOvertimeHours}
        </div>
      </div>
      <div className="card">
        <div style={{ fontSize: 'var(--text-sm)', color: 'var(--color-gray-600)' }}>
          Total Mileage (mi)
        </div>
        <div style={{ fontSize: 'var(--text-3xl)', fontWeight: 'var(--font-bold)' }}>
          {data.totalMileage}
        </div>
      </div>
      <div className="card">
        <div style={{ fontSize: 'var(--text-sm)', color: 'var(--color-gray-600)' }}>
          Mileage Reimbursement
        </div>
        <div style={{ fontSize: 'var(--text-3xl)', fontWeight: 'var(--font-bold)', color: 'var(--color-success)' }}>
          ${data.totalMileageReimbursement.toFixed(2)}
        </div>
      </div>
    </div>

    <div className="card">
      <h3 style={{ marginBottom: 'var(--spacing-4)' }}>By RBT</h3>
      <div className="table-container">
        <table className="table">
          <thead>
            <tr>
              <th>RBT Name</th>
              <th>Timesheets</th>
              <th>Total Hours</th>
              <th>Overtime</th>
              <th>Mileage (mi)</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {data.byRBT.map((rbt) => (
              <tr key={rbt.rbtId}>
                <td>{rbt.rbtName}</td>
                <td>{rbt.timesheetCount}</td>
                <td>{rbt.totalHours}</td>
                <td>{rbt.overtimeHours}</td>
                <td>{rbt.mileage}</td>
                <td>
                  <span
                    className={`badge badge-${
                      rbt.status === 'paid'
                        ? 'success'
                        : rbt.status === 'approved'
                        ? 'info'
                        : rbt.status === 'rejected'
                        ? 'error'
                        : 'warning'
                    }`}
                  >
                    {rbt.status}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  </div>
  );
};
